﻿module.exports = function ($scope) {
    var strings = {
        heb: {
            span1: "תנו לנו",
            span2: "לעבוד על",
            span3: "הפרויקט שלכם",
            mail: "דואר אלקטרוני",
            name: "שם",
            phone: "טלפון",
            text: "הודעה",
            btn: "בואו נדבר",
            privacyText: "קראתי, הבנתי והנני מסכים",
            privacyLink: "למדיניות הפרטיות באתר",
            privacyErr: "* נא לאשר את מדיניות הפרטיות"
        },
        eng: {
            span1: "Ready to",
            span2: "start a",
            span3: "project?",
            name: "Name",
            mail: "Email",
            phone: "Phone",
            text: "What's on your mind?",
            btn: "Lets talk!",
            privacyText: "i have read and understood",
            privacyLink: "the privacy policy",
            privacyErr: "* Approve privacy policy please"
        }
    }

    $scope.footerStrings = strings[$scope.lang];


}


//////////////////
// WEBPACK FOOTER
// ../scripts/yit/controllers/footer.js
// module id = 13
// module chunks = 0